import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { SocialAuthServiceConfig, GoogleLoginProvider, SocialLoginModule } from '@abacritt/angularx-social-login';
import { SignService } from '../../app.services/sign/sign.service';
import { SignComponent } from './components/sign.component';
import { RoutingModule } from './app.routes';
import { SignProvidersService } from '../../app.services/sign/sign-providers.service';
import { AppLogoComponent } from '@libs/stand-alone-components/commons/app-logo/app-logo.component';
import { ProvidersComponent } from './components/providers/providers.component';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';
import { TranstalerLoader } from '@libs/helper/translater.helper';
export const GOOGLE_LOGIN_PROVIDER = '184792630999-ebcptjmcb2vmhsc68ihpqgdcka2jhfc2.apps.googleusercontent.com';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [SignComponent],
  imports: [
    TranslateModule.forChild(TranstalerLoader),
    CommonModule,
    ReactiveFormsModule,
    RoutingModule,
    NgxMaskDirective,
    NgxMaskPipe,
    SocialLoginModule,
    AppLogoComponent,
    ProvidersComponent,
    IconComponent,
  ],
  providers: [
    provideNgxMask(),
    SignService,
    SignProvidersService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(GOOGLE_LOGIN_PROVIDER),
          },
        ],
        onError: err => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
  ],
})
export class AppModule {}
